import { Component, OnInit } from '@angular/core';

import { OfferBasicBoxComponent } from '../offer-basic-box/offer-basic-box.component';
import { LanguageService } from '../../../../../services/language.service';

@Component({
  selector: 'app-offer-primary-box',
  templateUrl: './offer-primary-box.component.html',
  styleUrls: ['./offer-primary-box.component.scss']
})
export class OfferPrimaryBoxComponent extends OfferBasicBoxComponent implements OnInit {

  constructor(lang: LanguageService) {
    super(lang);
  }

  ngOnInit() {
    this.setLabel();
  }
}
